import {SHARE_HIDE, SHARE_SHOW} from '../../../constants';
import * as Immutable from 'immutable';
const initialState = {
    status: 'HIDE',
    mask: 'HIDE'
};

/**
 *
 * @param state
 * @param action
 * @returns {*}
 */
export function share(state = initialState, action) {
    switch (action.type) {
        case SHARE_HIDE:
            return {status: 'HIDE'};
        case SHARE_SHOW:
            return {status: 'SHOW', mask: action.data.showMask, title: action.data.title};
        default:
            return state;
    }
}
